// extracted by mini-css-extract-plugin
export default {"image-area":"HeroImageArea-module__image-area__Bievf","image-hero-badge":"HeroImageArea-module__image-hero-badge__NDSso"};